export class KeyboardTrap {
    private _firstTabStop: HTMLElement;
    private _focusableElements: HTMLElement[];
    private _focusedElementBeforeModal: HTMLElement;
    private _lastTabStop: HTMLElement;
    private _selector: string;

    constructor(selector: string) {
        this._selector = selector;
        this._onInit();
    }

    private _onInit() {
        // Identify focusable elements
        this._focusedElementBeforeModal = document.activeElement as HTMLElement;
        const focusableElementsString = `a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]):not(.disabled), [tabindex="0"]`;
        this._focusableElements = Array.from(
            document.querySelector(this._selector)?.querySelectorAll<HTMLElement>(focusableElementsString) || [],
        );

        // Define first and last focusable element and set focus to first
        this._firstTabStop = this._focusableElements[0];
        this._lastTabStop = this._focusableElements[this._focusableElements.length - 1];
        this._firstTabStop?.focus();

        // Establish listener for tab key
        document.addEventListener(`keydown`, this.trapTabKey.bind(this));
    }

    /**
     * Forces tab key to move between focusable elemtns
     * @param eventObject
     */
    public trapTabKey(eventObject: KeyboardEvent) {
        if (eventObject.key === `Tab`) {
            if (eventObject.shiftKey) {
                if (document.activeElement === this._firstTabStop) {
                    eventObject.preventDefault();
                    this._focusedElementBeforeModal.focus();
                    this._focusedElementBeforeModal.click();
                }
            } else {
                if (document.activeElement === this._lastTabStop) {
                    eventObject.preventDefault();
                    this._focusedElementBeforeModal.focus();
                    this._focusedElementBeforeModal.click();
                }
            }
        }
    }
}
